// tokens.css MUST be first — establishes all custom properties and design-system classes
import './styles/tokens.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import * as Sentry from '@sentry/react'
import { AuthProvider } from './context/AuthContext'
import { initPosthogFromConfig } from './lib/posthog'
import App from './App.tsx'

// Initialize Sentry for v4 frontend error monitoring
// Uses VITE_SENTRY_DSN_V4 to route to the javascript-react Sentry project
Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN_V4,
  environment: import.meta.env.MODE,
  tracesSampleRate: 0.1,
  // Only initialize if DSN is configured (local dev = silent no-op)
  enabled: !!import.meta.env.VITE_SENTRY_DSN_V4,
})

// PostHog — same gate as app.html: init only when /api/config returns posthogKey
void initPosthogFromConfig()

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime:            30_000, // 30 s — dashboard tiles stay fresh
      retry:                1,      // one retry on network failure
      refetchOnWindowFocus: true,
    },
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <App />
        </AuthProvider>
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>,
)
